export default {"src":"/_next/static/media/MDB.cc4e1fae.svg","height":18,"width":18};